import {
  createRouter,
  createWebHashHistory,
  type RouteRecordRaw,
  type RouteLocationNormalized,
  type NavigationGuardNext,
} from "vue-router";
const history = createWebHashHistory();
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/HomeView",
  },
  {
    path: "/HomeView",
    name: "HomeView",
    component: () => import("@/views/homeView/index.vue"),
    redirect: "/Home",
    children: [
      {
        path: "/Home",
        name: "Home",
        component: () => import("@/views/Home/index.vue"),
      },
      {
        path: "/About",
        name: "About",
        component: () => import("@/views/About/index.vue"),
      },
      {
        path: "/news",
        name: "DetailDetach",
        component: () => import("@/views/DetailDetach/index.vue"),
        redirect: "/news/newsMain",
        children:[
          {
            path: "/news/newsMain",
            name: "newsMain",
           component: () => import("@/views/DetailDetach/newsMain.vue")
          },
          {
            path: "/news/newsParticulars",
            name: "newsparticulars",
            component: () => import("@/views/DetailDetach/newsParticulars.vue")
          },
        ]
      },
      {
        path: "/Weather",
        name: "Weather",
        component: () => import("@/views/Weather/index.vue"),
      },
      {
        path: "/contact",
        name: "contact",
        component: () => import("@/views/Us/index.vue"),
      },
      {
        path: "/product",
        name: "product",
        component: () => import("@/views/product/index.vue"),
      },
      {
        path: "/join",
        name: "join",
        component: () => import("@/views/JoinUs/index.vue"),
      },
      {
        path: "/support",
        name: "support",
        redirect: "/Home",
      },
      {
        path: "/test-responsive",
        name: "TestResponsive",
        component: () => import("@/views/TestResponsive/index.vue"),
      },
    ],
  },
];
const router = createRouter({
  history,
  routes,
});

export default router;
